import OurServicesBut from "../../butttons/OurServicesBut/OurServicesBut";
import AboutUs from "../../components/AboutUs/AboutUs";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";

export const AboutUsPage = () => {
  return (
    <div >
        <Header/>
      <AboutUs/>
      <OurServicesBut/>
      <Footer/>
    </div>
  );
};